import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IInfo, Info } from '../../../../../core/common';
import { NotifyType } from '../../../../../core/enums/NotifyType';
import { IMacro, IMasterData, Macro, MasterData } from '../../../../../core/models';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { CommonService } from '../../../../../core/services/common.service';
import { HelperService } from '../../../../../core/services/helper.service';
import { MacroService } from '../../../../../core/services/macro.service';
import { UserService } from '../../../../../core/services/user.service';

@Component({
  selector: 'app-edit-new-macro',
  templateUrl: './edit-new-macro.component.html',
  styleUrls: ['./edit-new-macro.component.scss']
})
export class EditNewMacroComponent implements OnInit {

  constructor(
    private userService: UserService,
    private formBuilder: FormBuilder,
    private macroService: MacroService,
    private router: Router,
    private route: ActivatedRoute,
    private helper: HelperService,
    private appNotifyService: AppNotifyService,
    private commonService: CommonService) {

    if (this.macroService.editmacro && this.macroService.editmacro.id) {
      this.editMacro = this.macroService.editmacro;
      this.editMacro.selectedtarget = { name: this.editMacro.target, value: this.editMacro.target } as IMasterData;
      this.editMacro.selectedType = { name: this.editMacro.type, value: this.editMacro.type } as IMasterData;
    } else {
      this.router.navigate(['../'], { relativeTo: this.route });
    }
  }

  ngOnInit(): void {
  }


  isSubmitted: boolean = false;
  saveInProcess: boolean = false;
  editMacro: IMacro = new Macro();
  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;
  public infoMessage: IInfo = new Info();

  get types(): MasterData[] {
    return this.macroService.types;
  }
  get targets(): MasterData[] {
    return this.macroService.targets;
  }


  validateForm(): boolean {
    return true;
  }

  targetValueChange(event: IMasterData, addMacro: IMacro): void {
    if (this.editMacro.selectedtarget) {
      this.editMacro.target = this.editMacro.selectedtarget.name;
    }

  }
  targetSelectionChange(event: IMasterData, addMacro: IMacro): void {
    if (this.editMacro.selectedtarget) {
      this.editMacro.target = this.editMacro.selectedtarget.name;
    }
  }

  typeValueChange(event: IMasterData, addMacro: IMacro): void {

    if (this.editMacro.selectedType) {
      this.editMacro.type = this.editMacro.selectedType.name;
    }

  }
  typeSelectionChange(event: IMasterData, addMacro: IMacro): void {

    if (this.editMacro.selectedType) {
      this.editMacro.type = this.editMacro.selectedType.name;
    }
  }

  updateMacroToSave(): void {
    this.isSubmitted = true;

    console.log(this.editMacro);
    //return;
    if (!this.validateForm()) {
      return;
    }
    this.infoMessage = new Info();
    this.inProgressMessage = true;
    this.saveInProcess = true;
    this.infoMessage.genericInProgress = this.infoMessage.genericInProgress;

    this.editMacro.userId = this.userService.readUserObject.userId;
    this.macroService.update(this.editMacro).subscribe((response) => {
      console.log(response);
      this.appNotifyService.notify(NotifyType.SUCCESS, "Updated Successfully");
      this.router.navigate(['../'], { relativeTo: this.route });
      this.infoMessage.genericInProgress = "";
      this.saveInProcess = false;
      if (response) {
        this.infoMessage.genericSuccess = this.infoMessage.genericSuccess;
      } else {
        this.infoMessage.genericError = this.infoMessage.genericError;
      }

      //this.editMacro = new Macro();
    })
  }


  
}
